var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowItWorksCol2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5714 8C12.6091 8 14.5122 8.58216 16.1263 9.59076C16.1999 9.63674 16.2814 9.69049 16.3709 9.75201L16.463 9.81613C16.9419 10.1533 17.0594 10.8187 16.7255 11.3023L16.6986 11.3395C16.4515 11.6664 16.2586 11.9415 16.1199 12.1649C14.9485 14.0519 14.2714 16.2834 14.2714 18.6746C14.2714 21.0646 14.9478 23.2951 16.1178 25.1815C16.237 25.3736 16.3961 25.6039 16.5953 25.8723L16.6982 26.0097C17.0524 26.4784 16.9633 27.1482 16.4992 27.5059L16.4626 27.5328C16.3291 27.6269 16.2108 27.7059 16.1079 27.77C14.4979 28.7715 12.6015 29.3493 10.5714 29.3493C4.73298 29.3493 0 24.5701 0 18.6746C0 12.7792 4.73298 8 10.5714 8Z",
    fill: "#DE5F28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4269 29.3493C34.2653 29.3493 38.9983 24.5701 38.9983 18.6746C38.9983 12.7792 34.2653 8 28.4269 8C22.5885 8 17.8555 12.7792 17.8555 18.6746C17.8555 24.5701 22.5885 29.3493 28.4269 29.3493Z",
    fill: "#DE5F28"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksCol2);
export default __webpack_public_path__ + "static/media/how-it-works-col-2.09308febf67e1d6acdfb42524ccd4fa2.svg";
export { ForwardRef as ReactComponent };